import * as React from 'react';
import Utils from '../../helpers/utils';
import * as CONST from '../../helpers/const';
import { get } from "jquery";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Button from '../../components/forms/button'
import { useState } from 'react';
import moment from "moment";
import { isMobile } from 'react-device-detect';

const IHN0101_ImgDetail = (props) => {
    if (props === null) { return ""; }
    let propData = props.data;
    if (propData === null || propData === undefined) {
        propData = null;
    }
    const propDataArray = [propData];
    
    const [quantity, setQuantity] = useState(0);

    function renderImage(){
        var imageUrl = propData.ImgSrc;
        if (null != imageUrl && !(imageUrl.indexOf("data:image") != -1)) {
            imageUrl = window.baseUrl + imageUrl; //support no app alias
        }
        return (
            <div className="img-detail-border" style={{ width: "100%", height: isMobile ? "auto" : "350px", minHeight: isMobile ? "200px" : undefined, display: "flex", alignItems:"flex-start", justifyContent:"center", overflow: "hidden" }} >
                <img className="display-hansoku-web" src={imageUrl} style={{ objectFit: "contain", maxWidth:"100%", maxHeight: isMobile ? "250px" : "100%",width: "auto", height: "auto" }} />
            </div>
        );
    }

    function renderTitleText(){
        return(
            <div className="row" style={{paddingTop:"15px", paddingBottom:'0px'}} >
                <div className="col-sm-12 col-md-12 col-lg-12" style={{ textAlign:"left" }}>
                    <p style={{display:"inline-block",float:"none",textAlign:"left",whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis", maxWidth: "100%", marginBottom:'0px'}}>
                        {propData.BunruiName1}
                    </p>
                </div>
               
                <div className="col-sm-12 col-md-12 col-lg-12" style={{ textAlign:"left", paddingTop: "10px" }}>
                     {Utils.isNullOrEmpty(propData.ItemDetailUrl) ? ( <p style={{display:"inline-block",float:"none",textAlign:"left",whiteSpace: "normal",overflow: "visible",textOverflow: "clip", maxWidth: "100%", fontWeight: "bold", marginBottom:'5px'}}>
                        {propData.HansokuName}
                    </p>
               ) :
                (
                    <a href={propData.ItemDetailUrl} target="_blank" rel="noopener noreferrer" style={{color: "black", display:"inline-block",float:"none",textAlign:"left",whiteSpace: "normal",overflow: "visible",textOverflow: "clip", maxWidth: "100%", fontWeight: "bold", marginBottom:'5px'}} title={propData.HansokuName}>
                        {propData.HansokuName}
                        <i className="fa fa-external-link-alt" style={{color :"black"}}></i>
                    </a>
                    
                )}
                 </div> 
            </div>
        );
    }

    function renderImageAndNotes() {
        return (
            <div className="row" style={{alignItems: "center", marginLeft: isMobile ? "0px" : undefined, marginRight: isMobile ? "0px" : undefined,}}>
                <div className="col-md-6 col-sm-12" style={{textAlign: "center", width: isMobile ? "100%" : undefined, paddingLeft: isMobile ? "0px" : undefined,paddingRight: isMobile ? "0px" : undefined, }}>
                    {renderImage()}
                </div>

                <div className="col-md-6 col-sm-12" style={{ width: isMobile ? "100%" : undefined,paddingLeft: isMobile ? "0px" : undefined,paddingRight: isMobile ? "0px" : undefined, }}>
                    {renderNotes()}
                </div>
            </div>
        );
    }

    function renderNotes() {
        return (
            <div className="row" style={{ paddingTop: isMobile ? "5px" : "15px", paddingBottom: "0px", marginLeft: isMobile ? "0px" : undefined, marginRight: isMobile ? "0px" : undefined, }}>
                <div className="col-12" style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", minHeight: isMobile ? "auto" : "350px", paddingLeft: isMobile ? "0px" : undefined, paddingRight: isMobile ? "0px" : undefined, }} >
                    <div style={{ textAlign: "left" }}>
                        <p style={{ whiteSpace: "nowrap", overflow: "hidden",  textOverflow: "ellipsis",  marginBottom: "5px",}} >
                            {propData.HansokuCodeDisp}
                    </p>
                    </div>

                    <div style={{ textAlign: "left" }}>
                        <p  style={{ display: "block", width: "100%", marginBottom: "0px",  wordBreak: "break-word", whiteSpace: "pre-line", }}>
                            {propData.RemarksDisp}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    function renderActionButtons(){

        const showPdfButton = !Utils.isNullOrEmpty(propData.SamplePdffileName);
        const pdfOnlyFlg = !propData.PdfonlyFlg;

        return (
            <div className="col-sm-12" style={{ marginTop: "20px",}}>
                <div className="row form-group" style={{ marginBottom: "0px", display: "flex", justifyContent: "center", alignItems: "center", }} >
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "20px",  maxWidth: "140px",  width: "100%", margin: "0 auto",  }} >
                        {pdfOnlyFlg && (
                            <input
                                type="number"
                                min="0"
                                max="50"
                                value={quantity}
                                onChange={(e) => {
                                    var value = Number(e.target.value);
                                    if (value > 50) value = 50;
                                    setQuantity(value);
                                }}
                            style={{  textAlign: 'right', width: "90px", height: "30px", fontSize: "16px",  }}/> 
                        )}
                        {pdfOnlyFlg && (
                            <Button icon="fa-shopping-cart"  color="success" className="flex-grow-0" style={{ width: "140px" }} label={props.getTranslateValue(props.translate.current, "views.ihn0101.addtocartbtn")} 
                                onClick={() => {
                                // handle add to cart
                                propData.IraiQt = quantity > 50 ? 50 : quantity;
                                props.handleAddToCart(propData);
                                }}
                            />
                        )}
                        {showPdfButton && (
                             <Button  icon="fa-file-pdf" color="primary" className="flex-grow-0" style={{ width: "130px", backgroundColor: "#8a532c", borderColor: "#8a532c", }} label={props.getTranslateValue(props.translate.current, "views.ihn0101.pdfdownload")}
                                onClick={() => {
                                // handle pdf download
                                props.downloadPDF(propData.SamplePdffileName, propData.HansokuCode, propData.HansokuSubCode)
                                 }}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }

    function renderActionButtonsMobile() {
        const showPdfButton = !Utils.isNullOrEmpty(propData.SamplePdffileName);
        const pdfOnlyFlg = !propData.PdfonlyFlg;

        return (
            <div className="col-sm-12" style={{ marginTop: "10px", paddingLeft: "0px", paddingRight: "0px" }} >
                <div className="row form-group" style={{ marginBottom: "0px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                    {pdfOnlyFlg && ( 
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", width: "90%", margin: "0 auto", }} > 
                            <input type="number" min="0" max="50" value={quantity === 0 ? "" : quantity} 
                                style={{ textAlign: "right", width: "40%", maxWidth: "40%", height: "30px", fontSize: "16px", }} 
                                onChange={(e) => { 
                                    var value = Number(e.target.value); 
                                    if (value > 50) value = 50; setQuantity(value); 
                                }} 
                            /> 
                            <Button icon="fa-shopping-cart" color="success" label={props.getTranslateValue( props.translate.current, "views.ihn0101.addtocartbtn")} 
                                className="flex-grow-0" style={{ width: "60%", minWidth: "120px", height: "30px", padding: "0px 8px", whiteSpace: "nowrap" }} 
                                onClick={() => { 
                                    // handle add to cart 
                                    propData.IraiQt = quantity > 50 ? 50 : quantity;
                                     props.handleAddToCart(propData); 
                                }} 
                            /> 
                        </div>
                    )}
                    {showPdfButton && (
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "90%", margin: "0 auto", }} >
                            <Button icon="fa-file-pdf" color="primary"  label={props.getTranslateValue( props.translate.current, "views.ihn0101.pdfdownload" )} className="flex-grow-0" style={{ width: "100%", maxWidth: "100%", height: "30px", padding: "0px", backgroundColor: "#8a532c", borderColor: "#8a532c", }}
                                onClick={() => {
                                    // handle pdf download
                                    props.downloadPDF(propData.SamplePdffileName, propData.HansokuCode, propData.HansokuSubCode);
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return(
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12" style={{ textAlign: 'center', paddingBottom:'15px' }}>
            {renderTitleText()}
            {renderImageAndNotes()}
            {isMobile? renderActionButtonsMobile(): renderActionButtons()}
            {isMobile && (<hr style={{ marginBottom: '0px' }} />)}
        </div>
    )
}

export default IHN0101_ImgDetail;


// WEBPACK FOOTER //
// ./view/IHN0101/IHN0101-imgdetail.jsx